import React, { useEffect } from 'react';

const AboutUsView = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen bg-slate-50 py-12 px-4 sm:px-6">
            <div className="max-w-4xl mx-auto space-y-12">
                <div className="text-center space-y-4">
                    <h1 className="text-4xl font-bold text-slate-800">About Us</h1>
                    <p className="text-lg text-slate-500">Your trusted neighborhood pharmacy, powered by Vimalaxmi Medical Store.</p>
                </div>

                <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 space-y-6">
                    <h2 className="text-2xl font-bold text-slate-800">Our Story</h2>
                    <p className="text-slate-600 leading-relaxed">
                        QwickMed was founded with a simple yet powerful mission: to make healthcare accessible, affordable, and deeply reliable for our local community. As a proud brand of Caretica World Private Limited, we partner with trusted local vendors like Vimalaxmi Medical Store to bring you genuine medicines and healthcare products right to your doorstep.
                    </p>
                    <p className="text-slate-600 leading-relaxed">
                        We understand that when it comes to health, trust is everything. That’s why we ensure every product we deliver meets the highest standards of quality and authenticity.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 text-center space-y-4">
                        <div className="w-16 h-16 bg-sky-50 rounded-full flex items-center justify-center text-sky-600 text-2xl mx-auto">
                            <i className="fas fa-heartbeat"></i>
                        </div>
                        <h3 className="font-bold text-slate-800 text-lg">Genuine Products</h3>
                        <p className="text-sm text-slate-500">We source directly from authorized distributors and manufacturers.</p>
                    </div>
                    <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 text-center space-y-4">
                        <div className="w-16 h-16 bg-sky-50 rounded-full flex items-center justify-center text-sky-600 text-2xl mx-auto">
                            <i className="fas fa-truck"></i>
                        </div>
                        <h3 className="font-bold text-slate-800 text-lg">Fast Delivery</h3>
                        <p className="text-sm text-slate-500">Quick and reliable delivery right to your home.</p>
                    </div>
                    <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 text-center space-y-4">
                        <div className="w-16 h-16 bg-sky-50 rounded-full flex items-center justify-center text-sky-600 text-2xl mx-auto">
                            <i className="fas fa-users"></i>
                        </div>
                        <h3 className="font-bold text-slate-800 text-lg">Community First</h3>
                        <p className="text-sm text-slate-500">Built for the local community, by the local community.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutUsView;
